<!-- =========================================================================================
    File Name: Maintenance.vue
    Description: Maintenance Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
            <img src="@/assets/images/pages/reset-password.png" alt="graphic-maintenance" class="mx-auto mb-4">
            <h1 v-if="is_verified" class="sm:mx-0 mx-4 mb-6 text-5xl d-theme-heading-color">Verification Successfully</h1>
            <h1 v-else class="sm:mx-0 mx-4 mb-6 text-5xl d-theme-heading-color">Verification Failed</h1>
            <p class="sm:mx-0 mx-4 mb-6 d-theme-text-inverse"></p>
            <vs-button size="large" to="/">Back to Home</vs-button>
        </div>
    </div>
</template>

<script>
import API from "@/API.js"
const axios = require('axios')
export default {
  data () {
    return {
      is_verified: false,
      loading: false
    }
  },
  components: {

  },

  created() {
    this.EmailVerified()
  },

  computed: {
		key() {
			return this.$route.params.key
		},
  },

  methods: {
    EmailVerified() {
      axios.post(API.base_url + '/api/email_subscription/verify/'+this.key, {
          key: this.key
      }).then(res => {
          this.is_verified = true
      }).catch(error => {
        this.is_verified = false
        if(error.response.status === 400){
        this.notify = 'Server Error'
        if(typeof error.response.data.message !== undefined) {
            this.notify = error.response.data.message.split('_').join(' ')
        }

        this.$vs.notify({
            title: 'Sorry',
            text: this.notify,
            color: 'danger',
            position: 'top-right'
        })
        }
      })
    }
  }


}
</script>
